import MetaModelRegistry from '@opsbase/lib-data-metamodel/MetaModelRegistry';
import QueryFieldKey from '@opsbase/lib-data-queryfield/QueryFieldKey';
import { DataType } from '@opsbase/lib-datatype/DataType/DataType';
import KeyCodes from '@opsbase/lib-general/KeyCodes';
import Palette from '@opsbase/lib-palette';
import useCss from '@opsbase/web-css';
import Horizontal from '@opsbase/web-layout/Horizontal';
import TextField from '@opsbase/web-textfield/TextField';
import React, { useCallback, useMemo, useRef, useState } from 'react';
import { PlaceFiltersMenu } from '../PlaceFiltersMenu/PlaceFiltersMenu';
import PlaceFiltersList from './PlaceFiltersList';
const makeMyClasses = hasAvailFilters => ({
    tray: {
        position: 'relative',
        minHeight: 42,
        borderRadius: 6,
    },
    trayinner: {
        position: 'absolute',
        marginLeft: hasAvailFilters ? 40 : 0,
        top: 0,
        zIndex: 102,
        minHeight: 42,
        maxHeight: 42,
        width: hasAvailFilters ? 'calc(100% - 40px)' : '100%',
        overflowY: 'hidden',
        backgroundColor: '#fff',
        borderRadius: '0 6px 6px 0',
        transition: 'max-height 0.3s, border-radius 0.3s',
        border: `1px solid ${Palette.LineGrey.main}`,
        '&:hover': {
            maxHeight: 300,
            overflowY: 'scroll',
            borderRadius: '0 6px 6px 6px',
        },
    },
    filtersCount: {
        position: 'absolute',
        top: 0,
        right: 0,
        width: 24,
        height: 24,
        opacity: 1,
        backgroundColor: Palette.LineGrey.main,
        borderRadius: '0 0 0 24px',
        zIndex: 101,
        textAlign: 'right',
        padding: '2px 4px 0 0',
        fontSize: 10,
    },
    root: {
        height: '100%',
        borderRadius: '5px 0 0 5px',
    },
});
export function PlaceFiltersBar(props) {
    const { filters = [], onAddFilter, onToggleFilter, onRemoveFilter } = props;
    const { filterables } = MetaModelRegistry[DataType.PLACE];
    const [filterText, setFilterText] = useState('');
    const availFilters = filterables.filter(f => !f.hidden);
    const hasAvailFilters = !!availFilters.length;
    const myCss = useCss(makeMyClasses, [hasAvailFilters]);
    const inputRef = useRef();
    const filterCount = filters === null || filters === void 0 ? void 0 : filters.length;
    const handleClickFilterList = useCallback(e => {
        e.stopPropagation();
        if (inputRef.current)
            inputRef.current.focus();
    }, []);
    const handleKeyUp = useCallback(e => {
        if (e.keyCode === KeyCodes.ENTER) {
            const filter = {
                queryFieldKey: QueryFieldKey.KEYWORD,
                id: filterText,
                title: filterText,
            };
            onToggleFilter(filter);
            setFilterText('');
        }
    }, [filterText, onToggleFilter]);
    return useMemo(() => (React.createElement(React.Fragment, null,
        React.createElement(Horizontal, { justify: 'flex-start', classes: { root: myCss.tray } },
            React.createElement(PlaceFiltersMenu, { filters: filters, onAddFilter: onAddFilter, onToggleFilter: onToggleFilter }),
            React.createElement(Horizontal, { classes: { root: myCss.trayinner }, gutter: true, centered: true, justify: "flex-start", flexWrap: "wrap", onClick: handleClickFilterList },
                React.createElement(PlaceFiltersList, { filters: filters, onRemoveFilter: onRemoveFilter }),
                React.createElement(TextField, { inputRef: ref => (inputRef.current = ref), noBorder: true, value: filterText, onChange: setFilterText, onKeyUp: handleKeyUp, InputProps: {
                        disableUnderline: true,
                    } })),
            !!filterCount && React.createElement("div", { className: myCss.filtersCount }, filterCount)))), [
        filterCount,
        filterText,
        filters,
        handleClickFilterList,
        handleKeyUp,
        myCss,
        onAddFilter,
        onRemoveFilter,
        onToggleFilter,
    ]);
}
export default PlaceFiltersBar;
